import React, { useState } from "react";
import {
  Card,
  CardContent,
  Typography,
  Select,
  MenuItem,
  FormControl,
  Grid,
  Input,
  Button,
} from "@mui/material";
import degericon from "../Assets/3563394.png";
import boilerimg from "../Assets/boilertran.png";
import boilersideimg from "../Assets/a_15.png";
import {
  SET_FETCH_TAG_VALUE_CONTROL,
  set_sıcak_su_sistemi,
  set_tag_values,
  set_external_trend_info,
  set_external_trend_info_cop
} from "../Action/Action";
import { connect } from "react-redux";
import Store from "../Store/Store";
import loading_ from "../Assets2/loading.gif";

import "./CSS/HotWaterBoiler.css";
import { useEffect } from "react";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { Link } from "react-router-dom/cjs/react-router-dom";

let state_2 = [
  {
    "P1 Akım Değeri": [{ tagId: "60" }],
  },
  {
    "P2 Akım Değeri": [{ tagId: "61" }],
  },
  {
    "Boyler Gidiş Kollektörü": [{ tagId: "60" }],
  },
  {
    "Boyler Dönüş Kollektörü": [{ tagId: "61" }],
  },

  {
    "Isıtma Gidiş Kollektörü": [{ tagId: "5054" }],
  },
  {
    "Isıtma Dönüş Kollektörü": [{ tagId: "5054" }],
  },

  { "Giriş Su Sıcaklığı(°C)": [{ tagId: "5008" }] },
  { "Çıkış Su Sıcaklığı(°C)": [{ tagId: "5007" }] },

  { "Anlık Debi(m³/h)": [{ tagId: "5010" }] },

  { "Toplam Geçen Su(m³)": [{ tagId: "5023" }] },
  { "Toplam Tüketim(kWh) ": [{ tagId: "8700" }] },
];

const inital_func = () => {
  var obj__ = [];
  var obj2__ = [];

  state_2.forEach((item) => {
    Object.entries(item).forEach((a) => {
      obj__.push(a[1]);
    });
  });

  obj__.forEach((item2) => {
    item2.forEach((item3) => {
      obj2__.push({ tagId: item3.tagId });
    });
  });

  setInterval(() => {
    const fetch_tag_values = async () => {
      if (window.location.pathname === "/boiler") {
        try {
          const request = await fetch(
            "https://rmmsapi.azurewebsites.net/api/tags/GetTagValues",
            {
              headers: {
                "Content-Type": "application/json",
                accept: "application/json",
              },
              method: "POST",
              body: JSON.stringify(obj2__),
            }
          );
          const response = await request.json();

          // response.forEach(a=>{
          //     liste.push(a)
          // })

          Store.dispatch(set_sıcak_su_sistemi(response));
        } catch (err) {
          console.log(err);
        } finally {
          Store.dispatch(SET_FETCH_TAG_VALUE_CONTROL(false));
        }
      }
    };
    fetch_tag_values();
  }, 20000);
};

setTimeout(() => {
  inital_func();
}, 1000);

const HotWaterBoiler = (props) => {
  const [controlMode, setControlMode] = React.useState("");
  const [command, setCommand] = React.useState("");
  const [state, Set_state] = useState(state_2);

  const handleControlModeChange = (event) => {
    setControlMode(event.target.value);
  };

  const handleCommandChange = (event) => {
    setCommand(event.target.value);
  };

  const history = useHistory();

  useEffect(() => {
    document.body.classList.add("hot-water-boiler-body");

    return () => {
      document.body.classList.remove("hot-water-boiler-body");
    };
  }, []);

  const year_trend = (e) => {
    e.preventDefault();

    function formatDate(date) {
      let year = date.getFullYear();
      let month = padZero(date.getMonth() + 1);
      let day = padZero(date.getDate());
      return `${year}-${month}-${day}`;
    }

    function padZero(value) {
      return value < 10 ? "0" + value : value;
    }

    try {
      let today = new Date();
      let tagId_ = document.querySelector(".show_tagId").textContent;

      let lastYear = new Date(today);
      lastYear.setFullYear(today.getFullYear() - 1);

      let todayFormatted = formatDate(today);
      let lastYearFormatted = formatDate(lastYear);

      let newObj = {
        inital_date: lastYearFormatted,
        tagId: tagId_,
        last_date: todayFormatted,
      };

      let newarray = [];
      newarray.push(newObj);
      Store.dispatch(set_external_trend_info(newarray));

      history.push("/work_orders");
    } catch (err) {
      console.error(err);
    }
  };

  const year_trend2 = async (e) => {
    e.preventDefault();

    document.querySelector(".export_loading").classList.toggle("export_loading_active")
    document.querySelector(".boiler_sec").classList.toggle("boiler_sec_blur")

    document.querySelector(".cyu").classList.toggle("cu_none")


    let id_list = ["8700", "134", "135", "136", "137", "138", "8729"]

    let Numerator = [];

    let Denominator = []

    for (let i = 0; i < id_list.length; i++) {

      let date1_, date2_;

      function formatTarih(tarih = new Date()) {
        const gun = String(tarih.getDate()).padStart(2, '0');
        const ay = String(tarih.getMonth() + 1).padStart(2, '0'); // Aylar 0-11 arasında olduğu için +1 ekliyoruz
        const yil = tarih.getFullYear();

        return `${yil}-${ay}-${gun}`;
      }

      function formatTarih2() {
        const tarih = new Date();
        tarih.setMonth(5); // 5. ay Haziran'ı temsil eder (0 tabanlı olduğu için 5, Haziran)
        tarih.setDate(1); // Ayın ilk günü olarak ayarlıyoruz

        const gun = String(tarih.getDate()).padStart(2, '0');
        const ay = String(tarih.getMonth() + 1).padStart(2, '0');
        const yil = tarih.getFullYear();

        return `${yil}-${ay}-${gun}`;
      }




      // Tarihleri formatlayarak alıyoruz
      const startDate = new Date(formatTarih2())
      const endDate = new Date(formatTarih());

      console.log(endDate, startDate);

      // Calculate the difference in days, months, and years
      const diffTime = Math.abs(endDate.getTime() - startDate.getTime());
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      const diffYears = endDate.getFullYear() - startDate.getFullYear();
      const diffMonths = (endDate.getFullYear() - startDate.getFullYear()) * 12 + (endDate.getMonth() - startDate.getMonth());

      // Determine the date ranges based on the difference in days, months, or years
      if (diffDays === 1) {
        date1_ = formatTarih2() + " " + "00:00:00.000";
        date2_ = formatTarih2() + " " + "23:59:59.999";
      } else if (diffYears >= 1) {
        // For yearly data
        const currentYear = new Date().getFullYear();
        date1_ = `${currentYear}-01-01 00:00:00.000`;
        date2_ = new Date().toISOString().replace('T', ' ').substr(0, 23);
      }
      else if (diffMonths >= 5) {
        const currentYear = new Date().getFullYear();

        date1_ = `${currentYear}-06-01 00:00:00.000`;
        date2_ = new Date().toISOString().replace('T', ' ').substr(0, 23);
      } else if (diffMonths >= 1) {
        // For monthly data
        const currentYear = new Date().getFullYear();
        const currentMonth = new Date().getMonth() + 1; // getMonth is 0-based, so add 1
        date1_ = `${currentYear}-${currentMonth < 10 ? '0' + currentMonth : currentMonth}-01 00:00:00.000`;
        date2_ = new Date().toISOString().replace('T', ' ').substr(0, 23);
      } else {
        date1_ = startDate + " " + "00:00:00.000";
        date2_ = endDate + " " + "23:59:59.999";
      }

      console.log(date1_, date2_, "allaaaaaaaa")
      function formatDate(date) {
        date = String(date).substring(0, date.length - 12)
        date = new Date(date)
        // Date nesnesini al ve UTC saatine göre düzenle
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Ay 0-11 arası olduğu için +1 yapıyoruz
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');
        const milliseconds = String(date.getMilliseconds()).padStart(3, '0');

        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}.${milliseconds}`;
      }
      date1_ = formatDate(date1_)
      date2_ = formatDate(date2_)
      let request = await fetch("https://rmmsapi.azurewebsites.net/api/tags/GetTagTrend", {
        method: "POST",
        headers: {
          'Content-Type': 'application/json',
          "Accept": "application/json"
        },
        body: JSON.stringify({ "TagId": id_list[i], "StartDate": date1_, "EndDate": date2_ })
      })

      let response = await request.json();



      let first_value = 0

      if (request.status === 200) {
        const step = Math.ceil(response.length / 15000); // Atlanacak miktarı hesapla
        let first_value = null;

        response.forEach((item, index) => {
          if (index % step === 0) { // Yalnızca belirli adımlarla ilerle
            if (first_value === null) {
              first_value = Number(item.tagValue);
            }

            if (id_list[i] === "8700") {
              Numerator.push({
                value: Number(item.tagValue) - first_value,
                date: item.valueDate,
                index: index,
                id: "8700"
              });
            } else {
              Denominator.push({
                value: Number(item.tagValue) - first_value,
                id: id_list[i],
                date: item.valueDate,
                index: index
              });
            }
          }
        });
      }



      await Store.dispatch(set_external_trend_info_cop([...Numerator, ...Denominator]))




    }

    setTimeout(() => {
      history.push("/work_orders")
      document.querySelector(".export_loading").classList.toggle("export_loading_active")
      document.querySelector(".boiler_sec").classList.toggle("boiler_sec_blur")

      document.querySelector(".cyu").classList.toggle("cu_none")
    }, 3000);


  };

  const [sebeke_toplam, Set_sebeke_toplam] = useState(0);

  const [final_cop, Set_final_cop] = useState(0)

  useEffect(() => {
    const componentDidMount = async () => {

      let id_list = ["8700", "134", "135", "136", "137", "138", "8729"]

      let Numerator = 0;

      let Denominator = 0

      for (let i of id_list) {

        let date1_, date2_;

        function formatTarih(tarih = new Date()) {
          const gun = String(tarih.getDate()).padStart(2, '0');
          const ay = String(tarih.getMonth() + 1).padStart(2, '0'); // Aylar 0-11 arasında olduğu için +1 ekliyoruz
          const yil = tarih.getFullYear();

          return `${yil}-${ay}-${gun}`;
        }

        function formatTarih2(tarih = new Date()) {
          // 1 gün eksik olması için bir gün çıkartıyoruz
          tarih.setDate(tarih.getDate() - 1);

          const gun = String(tarih.getDate()).padStart(2, '0');
          const ay = String(tarih.getMonth() + 1).padStart(2, '0');
          const yil = tarih.getFullYear();

          return `${yil}-${ay}-${gun}`;
        }


        // Tarihleri formatlayarak alıyoruz
        const startDate = new Date(formatTarih2())
        const endDate = new Date(formatTarih());

        console.log(endDate, startDate);

        // Calculate the difference in days, months, and years
        const diffTime = Math.abs(endDate.getTime() - startDate.getTime());
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
        const diffYears = endDate.getFullYear() - startDate.getFullYear();
        const diffMonths = (endDate.getFullYear() - startDate.getFullYear()) * 12 + (endDate.getMonth() - startDate.getMonth());

        // Determine the date ranges based on the difference in days, months, or years
        if (diffDays === 1) {
          date1_ = formatTarih2() + " " + "00:00:00.000";
          date2_ = formatTarih2() + " " + "23:59:59.999";
        } else if (diffYears >= 1) {
          // For yearly data
          const currentYear = new Date().getFullYear();
          date1_ = `${currentYear}-01-01 00:00:00.000`;
          date2_ = new Date().toISOString().replace('T', ' ').substr(0, 23);
        } else if (diffMonths >= 1) {
          // For monthly data
          const currentYear = new Date().getFullYear();
          const currentMonth = new Date().getMonth() + 1; // getMonth is 0-based, so add 1
          date1_ = `${currentYear}-${currentMonth < 10 ? '0' + currentMonth : currentMonth}-01 00:00:00.000`;
          date2_ = new Date().toISOString().replace('T', ' ').substr(0, 23);
        } else {
          date1_ = startDate + " " + "00:00:00.000";
          date2_ = endDate + " " + "23:59:59.999";
        }
        let request = await fetch("https://rmmsapi.azurewebsites.net/api/tags/GetTagTrend", {
          method: "POST",
          headers: {
            'Content-Type': 'application/json',
            "Accept": "application/json"
          },
          body: JSON.stringify({ "TagId": i, "StartDate": date1_, "EndDate": date2_ })
        })

        let response = await request.json();

        console.log(`Tag ${i} response:`, response?.length || 0, "kayıt");

        if (request.status === 200 && response && response.length > 0) {
          if (i === "8700") {
            let value1 = Number(response[0]?.tagValue || 0)
            let value2 = Number(response[response.length - 1]?.tagValue || 0)

            console.log(`Tag 8700 - İlk: ${value1}, Son: ${value2}, Fark: ${value2 - value1}`);

            let final_value = value2 - value1

            Numerator = final_value;

          } else {
            let value1 = Number(response[0]?.tagValue || 0)
            let value2 = Number(response[response.length - 1]?.tagValue || 0)

            console.log(`Tag ${i} - İlk: ${value1}, Son: ${value2}, Fark: ${value2 - value1}`);

            let final_value = value2 - value1

            Denominator += final_value
          }
        } else {
          console.log(`Tag ${i} - Veri yok veya hata`);
        }
      }

      // COP hesaplama - Denominator 0 ise NaN olmasını önle
      console.log("COP Hesaplama - Numerator:", Numerator, "Denominator:", Denominator);

      if (Denominator !== 0 && !isNaN(Numerator) && !isNaN(Denominator)) {
        const copValue = Number(Numerator) / Number(Denominator);
        console.log("Hesaplanan COP:", copValue);
        Set_final_cop(copValue)
      } else {
        console.log("COP hesaplanamadı - 0 olarak ayarlandı");
        Set_final_cop(0)
      }


    }

    componentDidMount()
  }, [])

  useEffect(() => {
    let value_ = 0;



    props.tag_values.filter((x) => {
      if (x.tagId === "8700") {
        console.log(x)
        value_ = Number(x.tagValue).toFixed(2);
      }
    });

    console.log(sebeke_toplam, props.cop)
    Set_sebeke_toplam(value_);
  }, [props.sıcak_sus_sistemi_tags]);

  const day_trend = (e) => {
    e.preventDefault();

    function formatDate(date) {
      let year = date.getFullYear();
      let month = padZero(date.getMonth() + 1);
      let day = padZero(date.getDate());
      return `${year}-${month}-${day}`;
    }

    function padZero(value) {
      return value < 10 ? "0" + value : value;
    }

    try {
      let today = new Date();
      let tagId_ = document.querySelector(".show_tagId").textContent;

      let yesterday = new Date(today);
      yesterday.setDate(today.getDate() - 1);
      let todayFormatted = formatDate(today);
      let yesterdayFormatted = formatDate(yesterday);

      let newObj = {
        inital_date: yesterdayFormatted,
        tagId: tagId_,
        last_date: todayFormatted,
      };
      let newarray = [];
      newarray.push(newObj);
      Store.dispatch(set_external_trend_info(newarray));

      history.push("/work_orders");
    } catch (err) {
      console.log(err);
    }
  };

  const day_trend2 = async (e) => {
    e.preventDefault();


    let id_list = ["8700", "134", "135", "136", "137", "138", "8729"]
    document.querySelector(".export_loading").classList.toggle("export_loading_active")
    document.querySelector(".boiler_sec").classList.toggle("boiler_sec_blur")

    document.querySelector(".cyu").classList.toggle("cu_none")
    let Numerator = [];

    let Denominator = []

    for (let i = 0; i < id_list.length; i++) {

      let date1_, date2_;

      function formatTarih(tarih = new Date()) {
        const gun = String(tarih.getDate()).padStart(2, '0');
        const ay = String(tarih.getMonth() + 1).padStart(2, '0'); // Aylar 0-11 arasında olduğu için +1 ekliyoruz
        const yil = tarih.getFullYear();

        return `${yil}-${ay}-${gun}`;
      }

      function formatTarih2(tarih = new Date()) {
        // 1 gün eksik olması için bir gün çıkartıyoruz
        tarih.setDate(tarih.getDate() - 1);

        const gun = String(tarih.getDate()).padStart(2, '0');
        const ay = String(tarih.getMonth() + 1).padStart(2, '0');
        const yil = tarih.getFullYear();

        return `${yil}-${ay}-${gun}`;
      }


      // Tarihleri formatlayarak alıyoruz
      const startDate = new Date(formatTarih2())
      const endDate = new Date(formatTarih());

      console.log(endDate, startDate);

      // Calculate the difference in days, months, and years
      const diffTime = Math.abs(endDate.getTime() - startDate.getTime());
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      const diffYears = endDate.getFullYear() - startDate.getFullYear();
      const diffMonths = (endDate.getFullYear() - startDate.getFullYear()) * 12 + (endDate.getMonth() - startDate.getMonth());

      // Determine the date ranges based on the difference in days, months, or years
      if (diffDays === 1) {
        date1_ = formatTarih2() + " " + "00:00:00.000";
        date2_ = formatTarih2() + " " + "23:59:59.999";
      } else if (diffYears >= 1) {
        // For yearly data
        const currentYear = new Date().getFullYear();
        date1_ = `${currentYear}-01-01 00:00:00.000`;
        date2_ = new Date().toISOString().replace('T', ' ').substr(0, 23);
      } else if (diffMonths >= 1) {
        // For monthly data
        const currentYear = new Date().getFullYear();
        const currentMonth = new Date().getMonth() + 1; // getMonth is 0-based, so add 1
        date1_ = `${currentYear}-${currentMonth < 10 ? '0' + currentMonth : currentMonth}-01 00:00:00.000`;
        date2_ = new Date().toISOString().replace('T', ' ').substr(0, 23);
      } else {
        date1_ = startDate + " " + "00:00:00.000";
        date2_ = endDate + " " + "23:59:59.999";
      }
      let request = await fetch("https://rmmsapi.azurewebsites.net/api/tags/GetTagTrend", {
        method: "POST",
        headers: {
          'Content-Type': 'application/json',
          "Accept": "application/json"
        },
        body: JSON.stringify({ "TagId": id_list[i], "StartDate": date1_, "EndDate": date2_ })
      })

      let response = await request.json();

      let first_value = 0

      if (request.status === 200) {
        response.forEach((item, index) => {
          if (index === 0) {
            first_value = Number(item.tagValue)
          }
          if (id_list[i] === "8700") {
            Numerator.push({ value: Number(item.tagValue) - first_value, date: item.valueDate, index: index, id: "8700" });
          } else {
            Denominator.push({ value: Number(item.tagValue) - first_value, id: id_list[i], date: item.valueDate, index: index })
          }
        })



      }

      await Store.dispatch(set_external_trend_info_cop([...Numerator, ...Denominator]))

    }

    setTimeout(() => {
      history.push("/work_orders")
      document.querySelector(".export_loading").classList.toggle("export_loading_active")
      document.querySelector(".boiler_sec").classList.toggle("boiler_sec_blur")

      document.querySelector(".cyu").classList.toggle("cu_none")
    }, 3000);

  };

  const month_trend = (e) => {
    e.preventDefault();

    function formatDate(date) {
      let year = date.getFullYear();
      let month = padZero(date.getMonth() + 1);
      let day = padZero(date.getDate());
      return `${year}-${month}-${day}`;
    }

    function padZero(value) {
      return value < 10 ? "0" + value : value;
    }

    try {
      let today = new Date();
      let tagId_ = document.querySelector(".show_tagId").textContent;

      let lastMonth = new Date(today);
      lastMonth.setMonth(today.getMonth() - 1);

      let todayFormatted = formatDate(today);
      let lastMonthFormatted = formatDate(lastMonth);

      console.log(todayFormatted, lastMonthFormatted);
      debugger;

      let newObj = {
        inital_date: lastMonthFormatted,
        tagId: tagId_,
        last_date: todayFormatted,
      };

      let newarray = [];
      newarray.push(newObj);
      Store.dispatch(set_external_trend_info(newarray));

      history.push("/work_orders");
    } catch (err) {
      console.log(err);
    }
  };

  const month_trend2 = async (e) => {
    e.preventDefault();

    document.querySelector(".export_loading").classList.toggle("export_loading_active")
    document.querySelector(".boiler_sec").classList.toggle("boiler_sec_blur")

    document.querySelector(".cyu").classList.toggle("cu_none")
    let id_list = ["8700", "134", "135", "136", "137", "138", "8729"]

    let Numerator = [];

    let Denominator = []

    for (let i = 0; i < id_list.length; i++) {

      let date1_, date2_;

      function formatTarih(tarih = new Date()) {
        const gun = String(tarih.getDate()).padStart(2, '0');
        const ay = String(tarih.getMonth() + 1).padStart(2, '0');
        const yil = tarih.getFullYear();

        return `${yil}-${ay}-${gun}`;
      }

      function formatTarih2() {
        const tarih = new Date();
        tarih.setDate(1); // Ayın ilk günü olarak ayarlıyoruz

        const gun = String(tarih.getDate()).padStart(2, '0');
        const ay = String(tarih.getMonth() + 1).padStart(2, '0');
        const yil = tarih.getFullYear();

        return `${yil}-${ay}-${gun}`;
      }




      // Tarihleri formatlayarak alıyoruz
      const startDate = new Date(formatTarih2())
      const endDate = new Date(formatTarih());

      console.log(endDate, startDate);

      // Calculate the difference in days, months, and years
      const diffTime = Math.abs(endDate.getTime() - startDate.getTime());
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      const diffYears = endDate.getFullYear() - startDate.getFullYear();
      const diffMonths = (endDate.getFullYear() - startDate.getFullYear()) * 12 + (endDate.getMonth() - startDate.getMonth());

      // Determine the date ranges based on the difference in days, months, or years
      if (diffDays === 1) {
        date1_ = formatTarih2() + " " + "00:00:00.000";
        date2_ = formatTarih2() + " " + "23:59:59.999";
      } else if (diffYears >= 1) {
        // For yearly data
        const currentYear = new Date().getFullYear();
        date1_ = `${currentYear}-01-01 00:00:00.000`;
        date2_ = new Date().toISOString().replace('T', ' ').substr(0, 23);
      } else if (diffMonths >= 1) {
        // For monthly data
        const currentYear = new Date().getFullYear();
        const currentMonth = new Date().getMonth() + 1; // getMonth is 0-based, so add 1
        date1_ = `${currentYear}-${currentMonth < 10 ? '0' + currentMonth : currentMonth}-01 00:00:00.000`;
        date2_ = new Date().toISOString().replace('T', ' ').substr(0, 23);
      } else {
        date1_ = startDate + " " + "00:00:00.000";
        date2_ = endDate + " " + "23:59:59.999";
      }
      function formatDate(date) {
        date = String(date).substring(0, date.length - 12)
        date = new Date(date)
        // Date nesnesini al ve UTC saatine göre düzenle
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Ay 0-11 arası olduğu için +1 yapıyoruz
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');
        const milliseconds = String(date.getMilliseconds()).padStart(3, '0');

        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}.${milliseconds}`;
      }
      date1_ = formatDate(date1_)
      date2_ = formatDate(date2_)

      console.log(date1_, date2_)
      let request = await fetch("https://rmmsapi.azurewebsites.net/api/tags/GetTagTrend", {
        method: "POST",
        headers: {
          'Content-Type': 'application/json',
          "Accept": "application/json"
        },
        body: JSON.stringify({ "TagId": id_list[i], "StartDate": date1_, "EndDate": date2_ })
      })

      let response = await request.json();

      let first_value = 0

      if (request.status === 200) {
        response.forEach((item, index) => {
          if (index === 0) {
            first_value = Number(item.tagValue)
          }
          if (id_list[i] === "8700") { Numerator.push({ value: Number(item.tagValue) - first_value, date: item.valueDate, index: index, id: "8700" }); } else {
            Denominator.push({ value: Number(item.tagValue) - first_value, id: id_list[i], date: item.valueDate, index: index })
          }
        })



      }

      console.log([...Numerator, ...Denominator]); debugger

      await Store.dispatch(set_external_trend_info_cop([...Numerator, ...Denominator]))




    }

    setTimeout(() => {
      history.push("/work_orders")
      document.querySelector(".export_loading").classList.toggle("export_loading_active")
      document.querySelector(".boiler_sec").classList.toggle("boiler_sec_blur")

      document.querySelector(".cyu").classList.toggle("cu_none")
    }, 3000);
  };

  const close_pop_up = (e) => {
    e.preventDefault();

    document
      .querySelector(".show_external_trend")
      .classList.toggle("show_external_trend_active");
  };

  const close_pop_up2 = (e) => {
    e.preventDefault();

    document
      .querySelector(".show_external_trend2")
      .classList.toggle("show_external_trend_active");
  };

  return (
    <>
      < div className="export_loading">
        <img style={{ width: "40%", position: "relative", left: "30%" }} src={loading_} alt="" />
        <p style={{ textAlign: "center" }}>COP grafiği hesaplanıyor. Bu işlem biraz zaman alabilir. Lütfen Bekleyiniz...</p>

      </div>
      <div className="show_pop_up show_external_trend">
        <i
          onClick={close_pop_up}
          style={{ position: "relative", left: "50%" }}
          className="fa fa-times close_tag_pop_up"
        ></i>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-around",
            width: "100%",
          }}
          className="top_flex"
        >
          <p>
            {" "}
            TagId: <span className="pop_up_x pop_up_external show_tagId"></span>
          </p>
          <p>
            {" "}
            TagName:{" "}
            <span className="pop_up_x pop_up_external show_tagName"></span>
          </p>
        </div>
        <div className="btn_area_popup_external">
          <button
            onClick={(e) => {
              day_trend(e);
            }}
          >
            Günlük Trend <i className="fa-solid fa-chart-line"></i>
          </button>
          <button
            onClick={(e) => {
              month_trend(e);
            }}
          >
            Aylık Trend <i className="fa-solid fa-chart-line"></i>
          </button>
          <button
            onClick={(e) => {
              year_trend(e);
            }}
          >
            Yıllık Trend <i className="fa-solid fa-chart-line"></i>
          </button>
        </div>
      </div>
      <div className="show_pop_up show_external_trend show_external_trend2">
        <i
          onClick={close_pop_up2}
          style={{ position: "relative", left: "50%" }}
          className="fa fa-times close_tag_pop_up"
        ></i>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-around",
            width: "100%",
          }}
          className="top_flex"
        >

          <p>
            COP
          </p>
        </div>
        <div className="btn_area_popup_external">
          <button
            onClick={(e) => {
              day_trend2(e);
              document.querySelector(".show_external_trend2").classList.toggle("show_external_trend_active")

            }}
          >
            Günlük Trend <i className="fa-solid fa-chart-line"></i>
          </button>
          <button
            onClick={(e) => {
              month_trend2(e);
              document.querySelector(".show_external_trend2").classList.toggle("show_external_trend_active")

            }}
          >
            Aylık Trend <i className="fa-solid fa-chart-line"></i>
          </button>
          <button
            onClick={(e) => {
              document.querySelector(".show_external_trend2").classList.toggle("show_external_trend_active")

              year_trend2(e);
            }}
          >
            Yıllık Trend <i className="fa-solid fa-chart-line"></i>
          </button>
        </div>
      </div>
      <div className="boiler_sec">
        <div className="cyu">
          <Link to="/hot_water_system">
            <Button
              style={{
                position: "absolute",
                color: "black",
                top: "15%",
                left: "18%",
                zIndex: 9999999,
                borderRadius: "15px",
                backgroundColor: "#fff",
                border: "3px solid rgba(238, 200, 108, 0.99)",
                fontWeight: 600,
              }}
              className=" movebuttons"
              variant="contained"
            >
              Geri
            </Button>
          </Link>
          <div style={{ position: "relative", width: "300px", height: "50px" }}>
            <img
              src={boilerimg}
              className="boiler-img"
              style={{
                width: "150px",
                height: "320px",
                position: "fixed",
                left: "59%",
                bottom: "18%",
              }}
            ></img>

            <svg
              className="ısıtma-gidis-cizgi"
              width="39%"
              height="50"
              style={{ position: "fixed", bottom: "34%", left: "21%" }}
            >
              <line
                x1="0"
                y1="25"
                x2="100%"
                y2="25"
                stroke="red"
                strokeWidth="8"
              />
              <polygon
                points="140,25 130,20 130,30"
                transform="scale(2)"
                transform-origin="-65 25"
                fill="red"
              />
              <line
                x1="120"
                y1="25"
                x2="120"
                y2="25"
                stroke="black"
                strokeWidth="14"
                markerEnd="url(#arrowhead)"
              />
            </svg>

            <svg
              className="ısıtma-donus-cizgi"
              width="39%"
              height="50"
              style={{ position: "fixed", top: "69%", left: "21%" }}
            >
              <line
                x1="0"
                y1="25"
                x2="100%"
                y2="25"
                stroke="red"
                strokeWidth="8"
              />
              <polygon
                points="120,25 130,20 130,30"
                transform="scale(2)"
                transform-origin="-45 25"
                fill="red"
              />
              <line
                x1="120"
                y1="25"
                x2="120"
                y2="25"
                stroke="black"
                strokeWidth="14"
                markerEnd="url(#arrowhead)"
              />
            </svg>

            <svg
              className="kullanım-donus-cizgi"
              style={{
                position: "fixed",
                top: "55%",
                left: "67.2%",
              }}
            >
              <line
                x1="0"
                y1="0"
                x2="40%"
                y2="0"
                stroke="red"
                strokeWidth="16"
              />
            </svg>
            <svg
              className="kullanım-gidis-cizgi"
              style={{
                position: "fixed",
                top: "48%",
                left: "67.2%",
              }}
            >
              <line
                x1="0"
                y1="0"
                x2="40%"
                y2="0"
                stroke="red"
                strokeWidth="16"
              />
            </svg>
            <svg
              className="sebeke-giris-cizgi"
              width="15%"
              height="50"
              style={{
                position: "fixed",
                top: "75%",
                left: "40%",
              }}
            >
              <line
                x1="100%"
                y1="25"
                x2="0"
                y2="25"
                stroke="aqua"
                strokeWidth="8"
              />
              <polygon
                points="0,25 10,20 10,30"
                transform="translate(0, -25) scale(2)"
                fill="aqua"
              />
              <line
                x1="120"
                y1="25"
                x2="120"
                y2="25"
                stroke="black"
                strokeWidth="14"
                markerEnd="url(#arrowhead)"
              />
            </svg>

            <div className="ws_kalorimetre">
              <p className="title">KALORİMETRE</p>
              {state.map((item, index) => {
                if (index >= 6) {
                  return Object.entries(item).map(
                    ([title, obj_], entryIndex) => {
                      return obj_.map((item_, objIndex) => {
                        return props.sıcak_sus_sistemi_tags.map(
                          (y, tagIndex) => {
                            if (item_.tagId === y.tagId) {
                              return (
                                <div
                                  className="row"
                                  key={`${entryIndex}-${objIndex}-${tagIndex}-${item_.tagId}`}
                                >
                                  <p>{title}</p>
                                  <div
                                    onContextMenu={(e) => {
                                      var tagName = props.tag_list
                                        .filter((b) => b.tagId === y.tagId)
                                        .map((c) => c.tagName)[0];

                                      e.preventDefault();
                                      const { clientX, clientY } = e;
                                      let screen_width = window.innerWidth;
                                      console.log(clientX, clientY);
                                      document
                                        .querySelector(".show_external_trend")
                                        .classList.toggle(
                                          "show_external_trend_active"
                                        );
                                      document.querySelector(
                                        ".show_tagId"
                                      ).innerHTML = y.tagId;
                                      document.querySelector(
                                        ".show_tagName"
                                      ).innerHTML = tagName;
                                      var popup = document.querySelector(
                                        ".show_external_trend"
                                      );
                                      const popupRect =
                                        popup.getBoundingClientRect();
                                      const viewportWidth = window.innerWidth;
                                      const viewportHeight = window.innerHeight;

                                      // Calculate the new positions
                                      let newX = clientX;
                                      let newY = clientY;

                                      // Adjust if the popup would overflow the right edge of the viewport
                                      if (
                                        newX + popupRect.width >
                                        viewportWidth
                                      ) {
                                        newX = viewportWidth - popupRect.width;
                                      }

                                      // Adjust if the popup would overflow the bottom edge of the viewport
                                      if (
                                        newY + popupRect.height >
                                        viewportHeight
                                      ) {
                                        newY =
                                          viewportHeight - popupRect.height;
                                      }

                                      // Adjust if the popup would overflow the left edge of the viewport
                                      if (newX < 0) {
                                        newX = 0;
                                      }

                                      // Adjust if the popup would overflow the top edge of the viewport
                                      if (newY < 0) {
                                        newY = 0;
                                      }

                                      if (
                                        screen_width < 2301 &&
                                        screen_width > 1800
                                      ) {
                                        document.querySelector(
                                          ".show_external_trend"
                                        ).style.left = `${String(
                                          newX / 1.2
                                        )}px`;
                                        document.querySelector(
                                          ".show_external_trend"
                                        ).style.top = `${String(newY / 1.2)}px`;
                                      } else if (
                                        screen_width < 2801 &&
                                        screen_width > 2300
                                      ) {
                                        document.querySelector(
                                          ".show_external_trend"
                                        ).style.left = `${String(
                                          newX / 1.5
                                        )}px`;
                                        document.querySelector(
                                          ".show_external_trend"
                                        ).style.top = `${String(newY / 1.5)}px`;
                                      } else if (
                                        screen_width < 3501 &&
                                        screen_width > 2800
                                      ) {
                                        document.querySelector(
                                          ".show_external_trend"
                                        ).style.left = `${String(
                                          newX / 1.8
                                        )}px`;
                                        document.querySelector(
                                          ".show_external_trend"
                                        ).style.top = `${String(newY / 1.8)}px`;
                                      } else if (
                                        screen_width < 5001 &&
                                        screen_width > 3500
                                      ) {
                                        document.querySelector(
                                          ".show_external_trend"
                                        ).style.left = `${String(
                                          newX / 2.5
                                        )}px`;
                                        document.querySelector(
                                          ".show_external_trend"
                                        ).style.top = `${String(newY / 2.5)}px`;
                                      } else if (screen_width <= 1800) {
                                        document.querySelector(
                                          ".show_external_trend"
                                        ).style.left = `${String(newX)}px`;
                                        document.querySelector(
                                          ".show_external_trend"
                                        ).style.top = `${String(newY)}px`;
                                      }
                                    }}
                                    className="value_div_"
                                  >
                                    {y.tagValue}
                                  </div>
                                </div>
                              );
                            } else {
                              return null;
                            }
                          }
                        );
                      });
                    }
                  );
                } else {
                  return null;
                }
              })}
              <div className="row">
                <p>COP</p>
                <div onContextMenu={(e) => {

                  e.preventDefault();
                  const { clientX, clientY } = e;
                  let screen_width = window.innerWidth;
                  console.log(clientX, clientY);
                  document
                    .querySelector(".show_external_trend2")
                    .classList.toggle(
                      "show_external_trend_active"
                    );

                  var popup = document.querySelector(
                    ".show_external_trend2"
                  );
                  const popupRect =
                    popup.getBoundingClientRect();
                  const viewportWidth = window.innerWidth;
                  const viewportHeight = window.innerHeight;

                  // Calculate the new positions
                  let newX = clientX;
                  let newY = clientY;

                  // Adjust if the popup would overflow the right edge of the viewport
                  if (
                    newX + popupRect.width >
                    viewportWidth
                  ) {
                    newX = viewportWidth - popupRect.width;
                  }

                  // Adjust if the popup would overflow the bottom edge of the viewport
                  if (
                    newY + popupRect.height >
                    viewportHeight
                  ) {
                    newY =
                      viewportHeight - popupRect.height;
                  }

                  // Adjust if the popup would overflow the left edge of the viewport
                  if (newX < 0) {
                    newX = 0;
                  }

                  // Adjust if the popup would overflow the top edge of the viewport
                  if (newY < 0) {
                    newY = 0;
                  }

                  if (
                    screen_width < 2301 &&
                    screen_width > 1800
                  ) {
                    document.querySelector(
                      ".show_external_trend2"
                    ).style.left = `${String(
                      newX / 1.2
                    )}px`;
                    document.querySelector(
                      ".show_external_trend2"
                    ).style.top = `${String(newY / 1.2)}px`;
                  } else if (
                    screen_width < 2801 &&
                    screen_width > 2300
                  ) {
                    document.querySelector(
                      ".show_external_trend2"
                    ).style.left = `${String(
                      newX / 1.5
                    )}px`;
                    document.querySelector(
                      ".show_external_trend2"
                    ).style.top = `${String(newY / 1.5)}px`;
                  } else if (
                    screen_width < 3501 &&
                    screen_width > 2800
                  ) {
                    document.querySelector(
                      ".show_external_trend2"
                    ).style.left = `${String(
                      newX / 1.8
                    )}px`;
                    document.querySelector(
                      ".show_external_trend2"
                    ).style.top = `${String(newY / 1.8)}px`;
                  } else if (
                    screen_width < 5001 &&
                    screen_width > 3500
                  ) {
                    document.querySelector(
                      ".show_external_trend"
                    ).style.left = `${String(
                      newX / 2.5
                    )}px`;
                    document.querySelector(
                      ".show_external_trend2"
                    ).style.top = `${String(newY / 2.5)}px`;
                  } else if (screen_width <= 1800) {
                    document.querySelector(
                      ".show_external_trend2"
                    ).style.left = `${String(newX)}px`;
                    document.querySelector(
                      ".show_external_trend2"
                    ).style.top = `${String(newY)}px`;
                  }
                }} className="value_div_">
                  {final_cop.toFixed(2)}
                </div>
              </div>
            </div>

            {state.map((item, index) => {
              if (index === 4) {
                var title = [];
                var obj_ = [];
                Object.entries(item).forEach((a) => {
                  title.push(a[0]);
                  obj_.push(a[1]);
                });
                return (
                  <Grid
                    style={{ width: "105px" }}
                    className={
                      index % 2 === 0 ? "ısıtma-gidis-div" : "ısıtma-donus-div"
                    }
                    sx={{
                      position: "fixed",
                      left: "16%",
                      top: index % 2 === 0 ? "60%" : "69%",
                    }}
                  >
                    <div
                      className="ısıtma-text1"
                      style={{
                        fontSize: "0.6rem",
                        textAlign: "center",
                        position: "fixed",
                        top: index % 2 === 0 ? "58%" : "68%",
                        left: "16%",
                      }}
                    >
                      {index % 2 === 0
                        ? "Isıtma Gidiş Kollektörü"
                        : "Isıtma Dönüş Kollektörü"}
                    </div>
                    <div
                      onContextMenu={(e) => {
                        var tagName = props.tag_list
                          .filter((b) => b.tagId === "5054")
                          .map((c) => c.tagName)[0];

                        e.preventDefault();
                        const { clientX, clientY } = e;
                        let screen_width = window.innerWidth;
                        console.log(clientX, clientY);
                        document
                          .querySelector(".show_external_trend")
                          .classList.toggle("show_external_trend_active");
                        document.querySelector(".show_tagId").innerHTML =
                          "5054";
                        document.querySelector(".show_tagName").innerHTML =
                          tagName;
                        var popup = document.querySelector(
                          ".show_external_trend"
                        );
                        const popupRect = popup.getBoundingClientRect();
                        const viewportWidth = window.innerWidth;
                        const viewportHeight = window.innerHeight;

                        // Calculate the new positions
                        let newX = clientX;
                        let newY = clientY;

                        // Adjust if the popup would overflow the right edge of the viewport
                        if (newX + popupRect.width > viewportWidth) {
                          newX = viewportWidth - popupRect.width;
                        }

                        // Adjust if the popup would overflow the bottom edge of the viewport
                        if (newY + popupRect.height > viewportHeight) {
                          newY = viewportHeight - popupRect.height;
                        }

                        // Adjust if the popup would overflow the left edge of the viewport
                        if (newX < 0) {
                          newX = 0;
                        }

                        // Adjust if the popup would overflow the top edge of the viewport
                        if (newY < 0) {
                          newY = 0;
                        }

                        if (screen_width < 2301 && screen_width > 1800) {
                          document.querySelector(
                            ".show_external_trend"
                          ).style.left = `${String(newX / 1.2)}px`;
                          document.querySelector(
                            ".show_external_trend"
                          ).style.top = `${String(newY / 1.2)}px`;
                        } else if (screen_width < 2801 && screen_width > 2300) {
                          document.querySelector(
                            ".show_external_trend"
                          ).style.left = `${String(newX / 1.5)}px`;
                          document.querySelector(
                            ".show_external_trend"
                          ).style.top = `${String(newY / 1.5)}px`;
                        } else if (screen_width < 3501 && screen_width > 2800) {
                          document.querySelector(
                            ".show_external_trend"
                          ).style.left = `${String(newX / 1.8)}px`;
                          document.querySelector(
                            ".show_external_trend"
                          ).style.top = `${String(newY / 1.8)}px`;
                        } else if (screen_width < 5001 && screen_width > 3500) {
                          document.querySelector(
                            ".show_external_trend"
                          ).style.left = `${String(newX / 2.5)}px`;
                          document.querySelector(
                            ".show_external_trend"
                          ).style.top = `${String(newY / 2.5)}px`;
                        } else if (screen_width <= 1800) {
                          document.querySelector(
                            ".show_external_trend"
                          ).style.left = `${String(newX)}px`;
                          document.querySelector(
                            ".show_external_trend"
                          ).style.top = `${String(newY)}px`;
                        }
                      }}
                      displayEmpty
                      value={command}
                      style={{
                        height: "35px",
                        zIndex: 999,
                        backgroundColor: "#fff",
                        paddingRight: 0,
                        border: "3px solid #edbc45",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        borderRadius: "4px",
                      }}
                    >
                      {" "}
                      {obj_[0].map((x, index) => {
                        console.log(x, obj_[0]);

                        if (index < 1) {
                          var değerler = props.sıcak_sus_sistemi_tags
                            .filter((a) => String(a.tagId) === String(x.tagId))
                            .map((b) => b.tagValue);

                          değerler = değerler[0];
                          değerler = String(değerler);
                          değerler = değerler.replaceAll(",", ".");
                          değerler = Number(değerler).toFixed(2);
                          değerler = String(String(değerler) + "°C");
                          return (
                            <div
                              className="MuiSelect-select MuiSelect-outlined MuiInputBase-input MuiOutlinedInput-input css-11u53oe-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input"
                              value=""
                              sx={{ zIndex: 999 }}
                            >
                              <em>{değerler}</em>
                            </div>
                          );
                        }
                      })}
                    </div>
                  </Grid>
                );
              } else if (index === 5) {
                var title = [];
                var obj_ = [];
                Object.entries(item).forEach((a) => {
                  title.push(a[0]);
                  obj_.push(a[1]);
                });
                return (
                  <Grid
                    style={{ width: "105px" }}
                    className={
                      index % 2 === 0 ? "ısıtma-gidis-div" : "ısıtma-donus-div"
                    }
                    sx={{
                      position: "fixed",
                      left: "16%",
                      top: index % 2 === 0 ? "59%" : "70%",
                    }}
                  >
                    <div
                      className="ısıtma-text2"
                      style={{
                        fontSize: "0.6rem",
                        textAlign: "center",
                        position: "fixed",
                        top: index % 2 === 0 ? "68%" : "68%",
                        left: "16%",
                      }}
                    >
                      {index % 2 === 0
                        ? "Isıtma Gidiş Kollektörü"
                        : "Isıtma Dönüş Kollektörü"}
                    </div>
                    <div
                      onContextMenu={(e) => {
                        var tagName = props.tag_list
                          .filter((b) => b.tagId === "5054")
                          .map((c) => c.tagName)[0];

                        e.preventDefault();
                        const { clientX, clientY } = e;
                        let screen_width = window.innerWidth;
                        console.log(clientX, clientY);
                        document
                          .querySelector(".show_external_trend")
                          .classList.toggle("show_external_trend_active");
                        document.querySelector(".show_tagId").innerHTML =
                          "5054";
                        document.querySelector(".show_tagName").innerHTML =
                          tagName;

                        var popup = document.querySelector(
                          ".show_external_trend"
                        );
                        const popupRect = popup.getBoundingClientRect();
                        const viewportWidth = window.innerWidth;
                        const viewportHeight = window.innerHeight;

                        // Calculate the new positions
                        let newX = clientX;
                        let newY = clientY;

                        // Adjust if the popup would overflow the right edge of the viewport
                        if (newX + popupRect.width > viewportWidth) {
                          newX = viewportWidth - popupRect.width;
                        }

                        // Adjust if the popup would overflow the bottom edge of the viewport
                        if (newY + popupRect.height > viewportHeight) {
                          newY = viewportHeight - popupRect.height;
                        }

                        // Adjust if the popup would overflow the left edge of the viewport
                        if (newX < 0) {
                          newX = 0;
                        }

                        // Adjust if the popup would overflow the top edge of the viewport
                        if (newY < 0) {
                          newY = 0;
                        }

                        if (screen_width < 2301 && screen_width > 1800) {
                          document.querySelector(
                            ".show_external_trend"
                          ).style.left = `${String(newX / 1.2)}px`;
                          document.querySelector(
                            ".show_external_trend"
                          ).style.top = `${String(newY / 1.2)}px`;
                        } else if (screen_width < 2801 && screen_width > 2300) {
                          document.querySelector(
                            ".show_external_trend"
                          ).style.left = `${String(newX / 1.5)}px`;
                          document.querySelector(
                            ".show_external_trend"
                          ).style.top = `${String(newY / 1.5)}px`;
                        } else if (screen_width < 3501 && screen_width > 2800) {
                          document.querySelector(
                            ".show_external_trend"
                          ).style.left = `${String(newX / 1.8)}px`;
                          document.querySelector(
                            ".show_external_trend"
                          ).style.top = `${String(newY / 1.8)}px`;
                        } else if (screen_width < 5001 && screen_width > 3500) {
                          document.querySelector(
                            ".show_external_trend"
                          ).style.left = `${String(newX / 2.5)}px`;
                          document.querySelector(
                            ".show_external_trend"
                          ).style.top = `${String(newY / 2.5)}px`;
                        } else if (screen_width <= 1800) {
                          document.querySelector(
                            ".show_external_trend"
                          ).style.left = `${String(newX)}px`;
                          document.querySelector(
                            ".show_external_trend"
                          ).style.top = `${String(newY)}px`;
                        }
                      }}
                      displayEmpty
                      value={command}
                      style={{
                        height: "35px",
                        zIndex: 999,
                        backgroundColor: "#fff",
                        paddingRight: 0,
                        border: "3px solid #edbc45",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        borderRadius: "4px",
                      }}
                    >
                      {" "}
                      {obj_[0].map((x, index) => {
                        console.log(x, obj_[0]);

                        if (index < 1) {
                          var değerler = props.sıcak_sus_sistemi_tags
                            .filter((a) => String(a.tagId) === String(x.tagId))
                            .map((b) => b.tagValue);

                          değerler = değerler[0];
                          değerler = String(değerler);
                          değerler = değerler.replaceAll(",", ".");
                          değerler = Number(değerler) - 5;
                          değerler = değerler.toFixed(2);
                          değerler = String(String(değerler) + "°C");
                          return (
                            <div
                              className="MuiSelect-select MuiSelect-outlined MuiInputBase-input MuiOutlinedInput-input css-11u53oe-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input"
                              value=""
                              sx={{ zIndex: 999 }}
                            >
                              <em>{değerler}</em>
                            </div>
                          );
                        }
                      })}
                    </div>
                  </Grid>
                );
              }
            })}

            {state.map((item, index) => {
              if (index < 2) {
                var title = [];
                var obj_ = [];
                Object.entries(item).forEach((a) => {
                  title.push(a[0]);
                  obj_.push(a[1]);
                });
                return (
                  <Grid
                    style={{ width: "105px" }}
                    className={
                      index % 2 === 0
                        ? "kullanım-gidis-div"
                        : "kullanım-donus-div"
                    }
                    sx={{
                      position: "fixed",
                      top: index % 2 === 0 ? "46%" : "54%",
                      left: "71.7%",
                    }}
                  >
                    <div
                      className={
                        index % 2 === 0 ? "kullanım-text1" : "kullanım-text2"
                      }
                      style={{
                        fontSize: "0.6rem",
                        textAlign: "center",
                        position: "fixed",
                        top: index % 2 === 0 ? "39%" : "50%",
                        left: "70%",
                      }}
                    >
                      {index % 2 === 0
                        ? "Kullanma Suyu Gidiş Kollektörü"
                        : "Kullanma Suyu Dönüş Kollektörü"}
                    </div>
                    <div
                      onContextMenu={(e) => {
                        e.preventDefault();
                        const { clientX, clientY } = e;
                        let screen_width = window.innerWidth;
                        let tagId__ = index % 2 === 0 ? "60" : "61";
                        var tagName = props.tag_list
                          .filter((b) => b.tagId === tagId__)
                          .map((c) => c.tagName)[0];

                        console.log(clientX, clientY);
                        document
                          .querySelector(".show_external_trend")
                          .classList.toggle("show_external_trend_active");
                        document.querySelector(".show_tagId").innerHTML =
                          index % 2 === 0 ? "60" : "61";
                        document.querySelector(".show_tagName").innerHTML =
                          tagName;

                        var popup = document.querySelector(
                          ".show_external_trend"
                        );
                        const popupRect = popup.getBoundingClientRect();
                        const viewportWidth = window.innerWidth;
                        const viewportHeight = window.innerHeight;

                        // Calculate the new positions
                        let newX = clientX;
                        let newY = clientY;

                        // Adjust if the popup would overflow the right edge of the viewport
                        if (newX + popupRect.width > viewportWidth) {
                          newX = viewportWidth - popupRect.width;
                        }

                        // Adjust if the popup would overflow the bottom edge of the viewport
                        if (newY + popupRect.height > viewportHeight) {
                          newY = viewportHeight - popupRect.height;
                        }

                        // Adjust if the popup would overflow the left edge of the viewport
                        if (newX < 0) {
                          newX = 0;
                        }

                        // Adjust if the popup would overflow the top edge of the viewport
                        if (newY < 0) {
                          newY = 0;
                        }

                        if (screen_width < 2301 && screen_width > 1800) {
                          document.querySelector(
                            ".show_external_trend"
                          ).style.left = `${String(newX / 1.2)}px`;
                          document.querySelector(
                            ".show_external_trend"
                          ).style.top = `${String(newY / 1.2)}px`;
                        } else if (screen_width < 2801 && screen_width > 2300) {
                          document.querySelector(
                            ".show_external_trend"
                          ).style.left = `${String(newX / 1.5)}px`;
                          document.querySelector(
                            ".show_external_trend"
                          ).style.top = `${String(newY / 1.5)}px`;
                        } else if (screen_width < 3501 && screen_width > 2800) {
                          document.querySelector(
                            ".show_external_trend"
                          ).style.left = `${String(newX / 1.8)}px`;
                          document.querySelector(
                            ".show_external_trend"
                          ).style.top = `${String(newY / 1.8)}px`;
                        } else if (screen_width < 5001 && screen_width > 3500) {
                          document.querySelector(
                            ".show_external_trend"
                          ).style.left = `${String(newX / 2.5)}px`;
                          document.querySelector(
                            ".show_external_trend"
                          ).style.top = `${String(newY / 2.5)}px`;
                        } else if (screen_width <= 1800) {
                          document.querySelector(
                            ".show_external_trend"
                          ).style.left = `${String(newX)}px`;
                          document.querySelector(
                            ".show_external_trend"
                          ).style.top = `${String(newY)}px`;
                        }
                      }}
                      displayEmpty
                      value={command}
                      style={{
                        height: "35px",
                        zIndex: 999,
                        backgroundColor: "#fff",
                        paddingRight: 0,
                        border: "3px solid #edbc45",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        borderRadius: "4px",
                      }}
                    >
                      {" "}
                      {obj_[0].map((x, index) => {
                        console.log(x, props.sıcak_sus_sistemi_tags);
                        if (index < 1) {
                          var değerler = props.sıcak_sus_sistemi_tags
                            .filter((a) => String(a.tagId) === String(x.tagId))
                            .map((b) => b.tagValue);

                          değerler = değerler[0];
                          değerler = String(değerler);
                          değerler = değerler.replaceAll(",", ".");
                          değerler = Number(değerler).toFixed(2);
                          değerler = String(String(değerler) + "°C");
                          return (
                            <div
                              className="MuiSelect-select MuiSelect-outlined MuiInputBase-input MuiOutlinedInput-input css-11u53oe-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input"
                              value=""
                              sx={{ zIndex: 999 }}
                            >
                              <em>{değerler}</em>
                            </div>
                          );
                        }
                      })}
                    </div>
                  </Grid>
                );
              }
            })}
          </div>
        </div>
      </div>
    </>
  );
};

const MapStateToProps = (state) => {
  return {
    pages_: state.project_reducer.pages,
    tag_ids: state.project_reducer.tag_ids,
    tag_values: state.project_reducer.tag_values,
    user_id: state.auth_reducer.user_id,
    company_id: state.project_reducer.company_id,
    tag_list: state.project_reducer.tag_list,
    white_space_: state.project_reducer.white_space_items,
    fetch_tag_value_control: state.project_reducer.fetch_tag_value_control,
    sıcak_sus_sistemi_tags: state.project_reducer.sıcak_su_sistem,
    cop: state.project_reducer.cop,
  };
};

export default connect(MapStateToProps)(HotWaterBoiler);
